<template>
  <div class="answer-area">
    <iframe
      v-if="editorUrl && [0, 2, 3, 4, 6].includes(activeAnswer.questionType)"
      :src="editorUrl"
      class="editor"
      ref="editor"
      allow="microphone;camera;midi;encrypted-media;"
    ></iframe>
    <div v-if="activeAnswer.typeId === 20" class="textarea-wrap">
      <p class="name">考生答案：</p>
      <p class="answer">{{ activeAnswer.answer }}</p>
    </div>
    <div v-if="activeAnswer.questionType === 1" class="textarea-wrap download-wrap">
      <p class="name">考生答案：</p>
      <div class="answer">
        <div class="has-answer" v-if="activeAnswer.answer">
          <icon-py-file class="icon icon-py-file"></icon-py-file>
          <p class="filename">{{ filename }}</p>
          <button class="download-btn" @click="downloadFile"><icon-download class="icon icon-download"></icon-download>考生答案下载</button>
        </div>
        <div v-else class="no-answer">
          <icon-no-answer class="icon-no-answer"></icon-no-answer>
          <p class="text">考生答案为空</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconDownload from '@/assets/svg/judge/download.svg'
import IconPyFile from '@/assets/svg/judge/py-file.svg'
import IconNoAnswer from '@/assets/svg/judge/icon-noanswer.svg'
import { downloadData } from '@/utils'
import { get } from '@/utils/ajax'

export default {
  components: {
    IconDownload,
    IconPyFile,
    IconNoAnswer
  },
  props: {
    activeAnswer: {
      type: Object
    },
    activeQuesInfo: {
      type: Object
    }
  },
  data() {
    return {
      editorUrl: '',
      filename: '',
      editorLink: '',
      blankBcm: 'https://public-static-edu.codemao.cn/eduexam/blank.bcm',
      uploadUrl: ''
    }
  },
  watch: {
    async activeQuesInfo(val) {
      this.uploadUrl = val.uploadUrl
    },
    async activeAnswer(val) {
      if ([10, 11, 12].includes(val.typeId)) { // 操作题
        switch (val.questionType) {
          case 0: // kitten
            const data = await get(`/edu/exams/works/kitten/code`, {
              bcm: this.uploadUrl || this.blankBcm
            })
            const code = val.answer || data
            this.editorUrl = `${window.CONFIG.ide}?code=${code}&pid=egLIJPgY`
            break
          case 1: // 上传文件
            this.filename = val.answer ? val.answer.split('/')[val.answer.split('/').length - 1] : ''
            break
          case 2: // python
            const pythonUrl = window.CONFIG.python
            if (this.editorUrl === pythonUrl) {
              this.initPython()
            } else {
              this.editorUrl = window.CONFIG.python
              this.toolListener()
            }
            break
          case 3: // scratch
            this.editorUrl = `${window.CONFIG.scratch}?work_url=${val.answer || this.uploadUrl}`
            break
          // eslint-disable-next-line no-fallthrough
          case 4: // nemo
            this.editorUrl = `${window.CONFIG.tanyuepigai}/edu?workUrl=${encodeURIComponent(val.answer || this.uploadUrl)}`
            break
          case 6: // c++
            const cplusplusUrl = window.CONFIG.cplusplus
            if (this.editorUrl === cplusplusUrl) {
              this.initCplusplus()
            } else {
              this.editorUrl = window.CONFIG.cplusplus
              this.toolListener()
            }
            break
        }
      }
    }
  },
  methods: {
    toolListener () {
      window.addEventListener('message', e => {
        const message = e.data
        switch (message.msg) {
          case 'wood_is_ready':
            this.initPython()
            break
        }
        switch (message.type) {
          case 'IFRAME_READY':
            this.initCplusplus()
            break
        }
      })
    },
    initPython () {
      if (!this.$refs.editor) {
        return
      }
      const python = this.$refs.editor.contentWindow
      // 设为代码模式
      python.postMessage(
        { msg: 'set_default_mode', mode: 'code' }, window.CONFIG.python
      )
      // 屏蔽切换模式按钮
      python.postMessage(
        { msg: 'set_mode_btn_display', mode: 'false' }, window.CONFIG.python
      )
      // 隐藏自带的缩放按钮
      python.postMessage(
        { msg: 'set_fullscreen_btn_display', is_display: false }, window.CONFIG.python
      )
      // 隐藏帮助按钮
      python.postMessage(
        { msg: 'set_help_btn_display', is_display: false }, window.CONFIG.python
      )
      // 打开海龟绘图
      python.postMessage(
        { msg: 'set_turtle_canvas_display', is_display: true }, window.CONFIG.python
      )
      // 设置初始化代码
      python.postMessage(
        { msg: 'set_python_code', code: this.activeAnswer.answer }, window.CONFIG.python
      )
    },
    initCplusplus() {
      if (!this.$refs.editor) {
        return
      }
      const cpp = this.$refs.editor.contentWindow

      // 设置UI
      cpp.postMessage({
        type: 'FEATURE_SET_CONFIG',
        payload: {
          headerDisabled: false, // 默认展示头部栏，true 则隐藏
          headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
          headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
          headerFileMenuItems: [
            // 'createProject',
            // 'openProjectManager',
            // 'workSaveAs',
            // 'divider',
            'openLocalFile',
            'exportAsCppFile'
            // 'divider',
            // 'importMiaoLink',
            // 'exportAsMiaoLink',
          ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
          userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
          workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
          workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
          disabledRegExp: true // 默认隐藏正则配置，false 则展示
        }
      }, window.CONFIG.cplusplus)

      // 设置答案
      cpp.postMessage({
        type: 'WORK_OPEN',
        payload: {
          work: {
            work_id: 0,
            name: '新的作品',
            extension: 'cpp',
            content: this.activeAnswer.answer,
            version: 0
          }
        }
      }, window.CONFIG.cplusplus)
    },
    downloadFile() {
      downloadData(this.activeAnswer.answer)
    }
  }
}
</script>

<style lang="scss" scoped>
  .answer-area {
    flex: 1;
    height: 100%;
  }
  .editor {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  .textarea-wrap {
    width: 100%;
    padding: 0 60px;
    .name {
      margin-top: 30px;
      font-size: 18px;
      color: #333;
    }
    .answer {
      background: rgba(56,126,253,0.03);
      border-radius: 8px;
      border: 1px solid $themeColor;
      height: 200px;
      padding: 10px 25px;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 500;
      color: #333;
    }
  }
  .download-wrap {
    .icon {
      display: inline-block;
    }
    .answer {
      display: flex;
      padding-top: 45px;
    }
    .filename {
      max-width: 256px;
      @include text-ellipsis(1);
      margin: 5px 20px 0 20px;
      font-size: 16px;
    }
    .download-btn {
      width: 160px;
      height: 42px;
      border-radius: 4px;
      border: 1px solid #397EFD;
      background: rgba(56, 126, 253, 0.03);
      color: $themeColor;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        background: $themeColor;
        color: #fff;
        .icon-download {
          fill: #fff;
        }
      }
    }
    .icon-download {
      fill: $themeColor;
      margin-right: 6px;
    }
    .no-answer {
      margin: -25px auto 0 auto;
    }
    .icon-no-answer {
      display: inline-block;
    }
    .text {
      font-size: 16px;
      text-align: center;
    }
    .has-answer {
      display: flex;
    }
  }
</style>
